import React, { useState, useEffect } from "react";
import style from "../CommonStyles/commonformstyles.module.scss";
import { useFetchKeyword } from "../../../../hooks/partnerHook/usePartnerService";

const ServiceDetailsForm = ({ formData, setFormData, handleNext }) => {
  const [keywordInput, setKeywordInput] = useState("");
  const [equipmentInput, setEquipmentInput] = useState("");
  const [suggestedKeywords, setSuggestedKeywords] = useState([]);
  const [suggestedEquipment, setSuggestedEquipment] = useState([]);
  const [errors, setErrors] = useState({});

  const { data: keywordsData, isLoading: isKeywordsLoading } =
    useFetchKeyword();

  const equipmentSuggestions = [
    "Drone Camera",
    "Thermal Imaging Camera",
    "GPS Tracker",
    "LIDAR Scanner",
    "Professional Lighting Kit",
  ];

  useEffect(() => {
    if (keywordsData) {
      setSuggestedKeywords(keywordsData);
    }
  }, [keywordsData]);

  useEffect(() => {
    setSuggestedEquipment(equipmentSuggestions);
  }, []);

  // Ensure formData has required fields
  useEffect(() => {
    if (
      !formData.serviceTitle ||
      !formData.serviceDescription ||
      !Array.isArray(formData.equipment) ||
      !Array.isArray(formData.keywords)
    ) {
      setFormData((prev) => ({
        ...prev,
        serviceTitle: prev.serviceTitle || "",
        serviceDescription: prev.serviceDescription || "",
        equipment: Array.isArray(prev.equipment) ? prev.equipment : [],
        keywords: Array.isArray(prev.keywords) ? prev.keywords : [],
        category: "", // Ensure empty string
        subCategory: "", // Ensure empty string
      }));
    }
  }, [formData, setFormData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Validate description field
    if (name === "serviceDescription") {
      setErrors((prev) => ({
        ...prev,
        serviceDescription:
          value.trim() === "" ? "Description is required" : "",
      }));
    }
  };

  const handleKeywordInputChange = (e) => {
    const value = e.target.value;
    setKeywordInput(value);

    if (value.trim() !== "") {
      const filtered =
        keywordsData?.filter((kw) =>
          kw.keyword.toLowerCase().includes(value.toLowerCase())
        ) || [];
      setSuggestedKeywords(filtered);
    } else {
      setSuggestedKeywords(keywordsData || []);
    }
  };

  const handleEquipmentInputChange = (e) => {
    const value = e.target.value;
    setEquipmentInput(value);

    if (value.trim() !== "") {
      const filtered = equipmentSuggestions.filter((eq) =>
        eq.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestedEquipment(filtered);
    } else {
      setSuggestedEquipment(equipmentSuggestions);
    }
  };

  const addKeyword = (keyword) => {
    if (
      (formData.keywords || []).length < 5 &&
      !(formData.keywords || []).includes(keyword)
    ) {
      setFormData({
        ...formData,
        keywords: [...(formData.keywords || []), keyword],
      });
    }
    setKeywordInput("");
  };

  const removeKeyword = (keywordToRemove) => {
    setFormData({
      ...formData,
      keywords: (formData.keywords || []).filter(
        (keyword) => keyword !== keywordToRemove
      ),
    });
  };

  const addEquipment = (equipment) => {
    if (
      !(formData.equipment || []).includes(equipment) &&
      equipment.trim() !== ""
    ) {
      setFormData({
        ...formData,
        equipment: [...(formData.equipment || []), equipment],
      });
    }
    setEquipmentInput("");
  };

  const removeEquipment = (equipmentToRemove) => {
    setFormData({
      ...formData,
      equipment: (formData.equipment || []).filter(
        (eq) => eq !== equipmentToRemove
      ),
    });
  };

  const isFormValid =
    (formData.serviceTitle || "").trim() !== "" &&
    (formData.serviceDescription || "").trim() !== "";

  if (isKeywordsLoading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <h2 className={style.dashboardFormContinerHeadingService}>
        Service Details
      </h2>
      <div className={style.dashboardFormInputContainer}>
        <label htmlFor="serviceTitle">
          <h3 className={style.labels}>Service Title</h3>
          <p className={style.noEquipmentDescriptionService}>
            As your Service storefront, your title is the most important place
            to include keywords that buyers would likely use to search for a
            service like yours.
          </p>
        </label>
        <div className={style.inputServiceField}>
          <span className={style.fixedPrefix}>I will</span>
          <input
            name="serviceTitle"
            id="serviceTitle"
            type="text"
            onChange={handleInputChange}
            value={formData.serviceTitle || ""}
            placeholder="do something..."
          />
        </div>
      </div>

      <div className={style.dashboardFormInputContainer}>
        <label htmlFor="serviceDescription">
          <h3 className={style.labels}>Service Description</h3>
          <p className={style.noEquipmentDescriptionService}>
            Provide a detailed description of the service you are offering to
            attract potential clients.
          </p>
        </label>
        <textarea
          name="serviceDescription"
          id="serviceDescription"
          value={formData.serviceDescription || ""}
          onChange={handleInputChange}
          placeholder="Describe your service..."
          className={`${style.textarea} ${
            errors.serviceDescription ? style.errorField : ""
          }`}
        />
        {errors.serviceDescription && (
          <p className={style.errorMessage}>{errors.serviceDescription}</p>
        )}
      </div>

      <div className={style.dashboardFormInputContainer}>
        <label htmlFor="equipment">
          <h3 className={style.labels}>Equipment You'll Use (Optional)</h3>
          {/* <p className={style.noEquipmentDescriptionService}>
            Choose if you've added the drone previously in the equipment section
          </p> */}
        </label>
        <div className={style.searchBar}>
          <input
            type="search"
            value={equipmentInput}
            onChange={handleEquipmentInputChange}
            placeholder="e.g. Drone Camera"
            className="searchField"
          />
          {equipmentInput && suggestedEquipment.length > 0 && (
            <ul className={`${style.suggestionList}`} style={{marginBottom: "10px"}}>
              {suggestedEquipment.map((equipment, index) => (
                <li
                  key={index}
                  onClick={() => addEquipment(equipment)}
                  className={style.suggestion}
                >
                  {equipment}
                </li>
              ))}
            </ul>
          )}
          <div>
            <p>
              Choose if you've added the drone previously in the equipment
              section. To add visit -- Equipment Section
            </p>
          </div>
        </div>
        <div className={style.selectedKeywords}>
          {(formData.equipment || []).map((equipment, index) => (
            <div key={index} className={style.keyword}>
              {equipment}
              <button
                type="button"
                onClick={() => removeEquipment(equipment)}
                className={style.removeKeyword}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* <div className={style.dashboardFormInputContainer}>
        <label htmlFor="serviceKeywords">
          <h3 className={style.labels}>Service Keywords</h3>
          <p className={style.noEquipmentDescriptionService}>
            Tag your Service with buzz words that are relevant to the services
            you offer. Use min 5 tags to get found.
          </p>
        </label>
        <div className={style.searchBar}>
          <input
            type="search"
            value={keywordInput}
            onChange={handleKeywordInputChange}
            placeholder="e.g. drone"
            className={`searchField ${errors.keywords ? "errorField" : ""}`}
          />
          {keywordInput && suggestedKeywords.length > 0 && (
            <ul className={style.suggestionList}>
              {(suggestedKeywords || []).map((keyword, index) => (
                <li
                  key={index}
                  onClick={() => addKeyword(keyword.keyword)}
                  className={style.suggestion}
                >
                  {keyword.keyword}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className={style.selectedKeywords}>
          {(formData.keywords || []).map((keyword, index) => (
            <div key={index} className={style.keyword}>
              {keyword}
              <button
                type="button"
                onClick={() => removeKeyword(keyword)}
                className={style.removeKeyword}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div> */}

      <div className={style.formButtonsContainer}>
        <button
          className={style.dashboardFormSaveButtonDown}
          onClick={handleNext}
          disabled={!isFormValid}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default ServiceDetailsForm;
